import { useEffect, useState } from "react";
import InputQuantity from "../../../commons/components/InputQuantity/InputQuantity";
import PrimaryButton from "../../../commons/components/PrimaryButton/PrimaryButton";
import { STORE_ADDRESS_URL } from "../../../commons/constants/api-urls";
import { MAIN_TAG_OPTIONS, SUB_TAG_OPTIONS } from "../../../commons/constants/product";
import useFetchList from "../../../commons/hooks/useFetchList";
import { OutlinedStarIcon } from "../../../commons/resources";
import { formatPrice } from "../../../commons/utils/functions/formatPrice";
import ProductVariants from "../ProductVariants/ProductVariants";
import styles from "./product-detail-header.module.scss";

interface ProductDetailHeaderProps {
  images: string[];
  name: string;
  price: number;
  description: string;
  sub_tags?: string[];
  attributes: ProductAttribute[];
  selectedVariants: any[];
  setSelectedVariant: (variant: SelectedVariant) => void;
  merchant_store_id: string;
  main_tags?: string | null;
}
const ProductDetailHeader: React.FC<ProductDetailHeaderProps> = ({
  images,
  name,
  price,
  description,
  sub_tags,
  attributes,
  selectedVariants,
  setSelectedVariant,
  merchant_store_id,
  main_tags,
}: ProductDetailHeaderProps) => {
  const [currentImage, setCurrentImage] = useState("");
  const [productPrice, setProductPrice] = useState(0);
  const [quantity, setQuantity] = useState(1);

  const { data: addresses } = useFetchList<MerchantStoreAddress>(
    merchant_store_id ? STORE_ADDRESS_URL(merchant_store_id) : "",
    {
      paginationMetadataStyle: "body",
      perPage: 2,
    }
  );

  useEffect(() => {
    if (selectedVariants.length === 0) {
      setProductPrice(+price);
    } else {
      const getTotalVariantPrice = (variant: any[]) => {
        if (!variant) return 0;

        return variant.reduce((total, price) => {
          return total + +price.price;
        }, 0);
      };

      const newPrice = selectedVariants.reduce(
        (total, variant) => total + getTotalVariantPrice(variant.selectedVariants),
        0
      );

      setProductPrice(newPrice + Number(price));
    }
  }, [selectedVariants, price]);

  useEffect(() => {
    if (images.length > 0) {
      setCurrentImage(images[0]);
    }
  }, [images]);

  return (
    <div className={styles.wrapper}>
      <div className={styles.imageWrapper}>
        <div className={styles.activeImage}>
          <img src={currentImage} alt="name" />
          <div className={styles.tag}>{MAIN_TAG_OPTIONS.find(tag => tag.value === main_tags)?.label}</div>
        </div>
        <div className={styles.smallImages}>
          {images.slice(0, 4).map((image, index) => (
            <img onClick={() => setCurrentImage(image)} src={image} key={index} alt="product" />
          ))}
        </div>
        <div className={styles.description}>
          <div className={styles.label}>Description</div>
          <div className={styles.content}>{description}</div>
        </div>
      </div>
      <div className={styles.info}>
        <div className={styles.nameWrapper}>
          <div className={styles.productName}>{name}</div>

          <div className={styles.price}>{formatPrice(productPrice)}</div>
        </div>

        <ProductVariants
          attributes={attributes}
          selectedVariants={selectedVariants}
          setSelectedVariant={setSelectedVariant}
        />
        <div className={styles.quantityWrapper}>
          <p className={styles.quantityText}>Quantity </p>
          <InputQuantity quantity={quantity} onChange={setQuantity} max={9999} />
        </div>
        <PrimaryButton>Add to cart</PrimaryButton>
      </div>
    </div>
  );
};

export default ProductDetailHeader;
